<!--
 * @Description: 报名表单页票种弹框
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-05-26 14:50:34
 * @LastEditors: 山淑兰
 -->
<template>
	<div class="num_popup_container">
		<div class="ticketType" v-if="ticketTypeList.length">
			<div class="ticketType_title">请选择</div>
			<div class="ticketType_item" v-for="(item, index) in ticketTypeList" :key="index">
				<div class="ticketType_item_main" :class="{
            ticketType_select: flags.selectTicket == index && isCanChoose(item),
          }" @click="handleClickChooseTicket(index, item)">
					<div class="ticketType_item_container">
						<div :class="{ prohibit: !isCanChoose(item) }" class="ticket_type">
							{{ item.type_name }} {{ item.show }}
						</div>
						<div class="price_container" :class="{ prohibit: !isCanChoose(item) }">
							¥
							<span class="price" :checkedTicket="index">{{ item.money }}</span>
						</div>
					</div>
				</div>
				<div class="ticketTypeTips" v-show="item.is_check && flags.is_check === index">
					该票种需主办方审核
				</div>
			</div>
		</div>
		<!-- 如果没有开启多人报名 不展示选择人数 -->
		<div id="select_number" v-if="signUpOpts.is_multiuser && !datas.isMore">
			<div class="select_number_container">
				<div class="select_number_title">请选择报名人数</div>
				<div class="select_number_content">
					<div class="reduce" @click="handleClickOperation('reduce')">
						<img src="@assets/reduce.png" alt />
					</div>

					<input type="text" v-model="count" class="num" readonly />
					<div class="increase" @click="handleClickOperation('add')">
						<img src="@assets/increase.png" alt />
					</div>
					<div class="remainingTickets">
						<template v-if="signUpOpts.is_multiuser">
							<span v-if="currentTicket.limit_number">(每人限报{{ currentTicket.limit_number }}张)</span>
							<span
								v-if="!ticketTypeList.length && signUpOpts.limit_population">(每人限报{{ signUpOpts.limit_population }}张)</span>
						</template>
						<span v-if="ticketTypeList.length && currentTicket.headcount">剩余{{ surplusTicket }}张</span>
					</div>
				</div>
			</div>
		</div>
		<div class="num_popup_bottom nextStep">
			<div class="total_container nextStep_container" v-if="ticketTypeList.length">
				合计：
				<span>
					¥
					<span class="total">{{
            (this.currentTicket.money * this.count).toFixed(2)
          }}</span>
				</span>
			</div>
			<div class="num_popup_confirm nextBtn" @click="handleClickSubmit()">
				确定
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		neme: 'chooseTicketModal',
		components: {},
		props: {
			datas: {
				type: Object,
				default () {
					return {}
				},
			},
		},
		data() {
			return {
				count: 1, // 人数
				surplusTicket: 0, // 剩余票数
				currentTicket: {}, // 当前选中的票的数据
				signUpOpts: {
					is_multiuser: 0
				}, // 报名配置
				flags: {
					selectTicket: 0, //选中票的索引
					is_check: 0, //显示 ‘该票种需主办方审核’ 文案
				},
				ticketTypeList: [], // 票类型列表
			}
		},

		computed: {
			meetId() {
				return this.$route.query.m
			},
		},
		created() {},
		mounted() {
			const {
				SignUpSetType: ticketTypeList,
				...signUpOpts
			} = this.datas
			if (ticketTypeList) {
				// 遍历数据 判断第几个被选中
				for (let i = 0; i < ticketTypeList.length; i++) {
					// const item = ticketTypeList[i]
					// if (this.isCanChoose(item)) {
					// 	this.surplusTicket = item.surplus_population

					// 	this.handleChooseTicket(i, item)
					// 	break
					// }
					
					//break
				}
				if( ticketTypeList && ticketTypeList.length > 0 ){
					this.surplusTicket = ticketTypeList[0].surplus_population
					this.handleChooseTicket(0, ticketTypeList[0])
				}
				
				this.count = this.datas.ssl_count || 1
				this.ticketTypeList = ticketTypeList
				this.signUpOpts = signUpOpts
			}
		},

		methods: {
			handleChooseTicket(i, item) {
				Object.assign(this.flags, {
					selectTicket: i,
					is_check: i,
				})
				console.log('item',item)
				this.currentTicket = item
				this.surplusTicket = item.surplus_population
				// headcount 为0 不需要查询余票
				if (item.headcount) {
					this.fetchGetSurplusTicket(item)
				}

			},
			/**
			 * @description: 查询余票
			 * @param {number} settypeid 票种id
			 */
			async fetchGetSurplusTicket({
				settypeid
			}) {
				const _params = {
					m: this.meetId,
					settypeid,
				}
				try {
					const res = await this.$http.QuerySignRemaining(_params)
					if (res.Code === 1000) {
						this.surplusTicket = res.Count
					}
					console.log('根据票种类型查询余票接口:', res)
				} catch (error) {
					console.log(error)
				}
			},
			/**
			 * @description: 判断是否可以选中
			 * @param {number} surplus_population 剩余人数 等于0 则不可点击
			 * @param {number} headcount 总人数 等于0 则代表没有限制人数
			 * @returns true 代表可以选中 false 反之
			 */
			isCanChoose({
				surplus_population,
				headcount
			}) {
				if (surplus_population === 0 && headcount != 0) {
					return false
				}
				// if ( headcount == 0){
				// 	return false
				// }
				return true
			},
			/**
			 * @description: 选中票种
			 */
			handleClickChooseTicket(index, item) {
				if (!this.isCanChoose(item)) return
				this.handleChooseTicket(index, item)
				this.count = 1
			},
			/**
			 * @description: 加减操作人数
			 * @param {string} type reduce:减 add:加
			 */
			handleClickOperation(type) {
				//   if (!this.isCanChoose(item)) return

				const {
					limit_number,
					headcount
				} = this.currentTicket
				const {
					count,
					signUpOpts,
					ticketTypeList
				} = this

				switch (type) {
					case 'add':
						//有票种，先判断票数;否则去判断限报
						if (ticketTypeList.length) {
							// 总票和该票限制人数都为0，
							if (!limit_number && !headcount) {
								this.count++
							} else {
								// limit_number 为0 不限购
								if (!limit_number) {
									if (count < this.surplusTicket) {
										this.count++
									}
								} else {
									// count(人数) 小于余票 和 票的限制数量
									if (!headcount) {
										if (count < limit_number) {
											this.count++
										}
									} else if (count < this.surplusTicket && count < limit_number) {
										this.count++
									}
								}
							}
							// 小与 当前账户的限制数量
						} else if (signUpOpts.limit_population == 0) {
							this.count++
						} else if (signUpOpts.limit_population > 0) {
							if (count < signUpOpts.limit_population) {
								this.count++
							}
						}
		 			// else if (count < signUpOpts.limit_population) {
						//         this.count++
						//       }

						break
					case 'reduce':
						if (count > 1) {
							this.count--
						}
						break
				}
			},
			/**
			 * @description: 确定按钮
			 */
			handleClickSubmit() {
				const {
					settypeid,
					money
				} = this.currentTicket
				const {
					count
				} = this
				if( this.ticketTypeList.length > 0 ){
					const surplusTicket = this.surplusTicket
					this.$emit('submit', {
						settypeid,
						money,
						count,
						totalMoney: money * count,
						surplusTicket,
					})
				}else{
					this.$emit('submit', {
						settypeid,
						money,
						count,
						totalMoney: money * count,
					})
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.num_popup_container {
		width: 92%;
		position: absolute;
		top: 46%;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0 0 4px #9a9797;
		border-radius: 4px;
		padding-top: 20px;
		font-size: 28px;
		background: #fff;
		margin: 0 auto;

		.ticketType_select {
			border: 2px solid #1989fa;

			&::after {
				content: '';
				position: absolute;
				bottom: 0;
				right: 0;
				border-bottom: 30px solid #1989fa;
				border-left: 30px solid transparent;
				border-top: 30px solid transparent;
			}
		}

		.ticketType {
			width: 92%;
			margin: 0 auto;

			.ticketType_title {
				font-size: 28px;
				height: 80px;
				line-height: 80px;
			}

			.ticketType_item {
				width: 100%;
				height: 134px;
				font-size: 28px;

				.ticketType_item_main {
					box-sizing: border-box;
					padding: 0 3%;
					background: #f9f9f9;
					box-shadow: 0 0 6px #aaa;
					border-radius: 4px;
					position: relative;
				}

				.ticketType_item_container {
					height: 90px;
					display: flex;
					justify-content: space-between;

					.ticket_type {
						flex: 1;
						display: flex;
						align-items: center;
					}

					.price_container {
						font-size: 32px;
						color: orange;
						width: 120px;
						display: flex;
						align-items: center;
						justify-content: flex-end;
					}

					.prohibit {
						color: #aaa;
					}
				}

				.ticketTypeTips {
					height: 40px;
					line-height: 50px;
					font-size: 26px;
					color: #d8b019;
				}
			}
		}

		#select_number {
			width: 92%;
			margin: 0 auto;

			.select_number_container {
				.select_number_title {
					font-size: 28px;
					height: 100px;
					line-height: 100px;
				}

				.select_number_content {
					height: 100px;
					line-height: 100px;
					color: #999;
					display: flex;
					align-items: center;
					align-content: center;

					.reduce,
					.increase {
						width: 66px;
						height: 60px;
						line-height: 40px;
						background: #f1f2f3;
						font-size: 60px;
						text-align: center;
						position: relative;

						>img {
							width: 70%;
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
						}
					}

					.reduce {
						>img {
							width: 50%;
						}
					}

					.num {
						height: 56px;
						width: 66px;
						text-align: center;
						line-height: 62px;
						font-size: 28px;
						background: #fff;
						border-radius: 0;
						box-shadow: 0 0 1px #aaa;
						margin: 0 4px;
						color: #000;

						&::placeholder {
							font-size: 62px;
						}
					}

					.remainingTickets {
						display: inline-block;
						margin-left: 4%;
					}
				}
			}
		}
	}

	.nextStep {
		display: flex;
		height: 96px;
		line-height: 108px;
		margin-top: 50px;
		font-size: 28px;

		.nextStep_container {
			border-top: 2px solid #f3f3f3;
			flex: 1;
			padding-left: 4%;

			>span {
				font-size: 32px;
				color: orange;
			}
		}

		.nextBtn {
			flex: 1;
			height: 96px;
			line-height: 96px;
			text-align: center;
			background: #289adc;
			color: #fff;
			letter-spacing: 10px;
			font-size: 30px;
		}
	}
</style>
